// TREATX-TAX-5 — provider treatment VAT, composer ⇄ backend mapping.
//
// The PROVIDER owns this determination: TreatX records basis, treatment and
// rate and never suggests or infers a rate. This module performs NO financial
// derivation — net / VAT / patient total are always read back from the
// backend `financial_summary` (single canonical authority).

export const TAX_BASIS_EXCLUSIVE = 'VAT_EXCLUSIVE';
export const TAX_BASIS_INCLUSIVE = 'VAT_INCLUSIVE';
export const TAX_TREATMENT_APPLICABLE = 'VAT_APPLICABLE';
export const TAX_TREATMENT_EXEMPT = 'VAT_EXEMPT';

/** Composer state seed. Revisions inherit the predecessor's declaration. */
export const providerTaxDefaults = (existingOffer) => {
  const pt = existingOffer?.provider_tax || null;
  return {
    taxDeclared: !!pt,
    taxBasis: pt?.basis || TAX_BASIS_INCLUSIVE,
    taxTreatment: pt?.treatment || TAX_TREATMENT_APPLICABLE,
    taxRatePercent: pt?.rate_bps != null ? String(pt.rate_bps / 100) : '',
    taxExemptionReason: pt?.exemption_reason || '',
  };
};

/** Backend `provider_tax` payload, or null when the provider declared nothing. */
export const buildProviderTaxPayload = (d) => {
  if (!d || !d.taxDeclared) return null;
  const exempt = d.taxTreatment === TAX_TREATMENT_EXEMPT;
  return {
    basis: d.taxBasis,
    treatment: d.taxTreatment,
    rate_bps: exempt ? 0 : Math.round(parseFloat(d.taxRatePercent || 0) * 100),
    exemption_reason: exempt ? (d.taxExemptionReason || '').trim() : null,
  };
};

/** UI-boundary validation. Returns an i18n key, or null when valid. */
export const validateProviderTax = (d) => {
  if (!d || !d.taxDeclared) return null;
  if (d.taxTreatment === TAX_TREATMENT_EXEMPT) {
    return (d.taxExemptionReason || '').trim() ? null : 'offer.tax.errors.reasonRequired';
  }
  const rate = parseFloat(d.taxRatePercent);
  if (!Number.isFinite(rate) || rate <= 0 || rate > 100) return 'offer.tax.errors.rateRequired';
  return null;
};
